import { isMobileBrowser } from '@rover/utilities/device';
import { getRouteURL } from '@rover/utilities/deeplink';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import { isAndroid, isMobileEmbedded } from '@rover/utilities/userAgent';

export default class {
  static closeBanner() {
    $('.js-app-banner').addClass('hidden');
    $('body').removeClass('has-banner');
    $.cookie('appBanner', true, { expires: 90 });
  }

  static isPossibleBanner() {
    if (!$.cookie('appBanner')) {
      return true;
    }
    return false;
  }

  static init() {
    if (
      !isMobileBrowser() ||
      !this.isPossibleBanner() ||
      isMobileEmbedded() ||
      $('body').hasClass('no-banner') ||
      !Rover.context.supportsMobileApp
    ) {
      return;
    }

    const appInstallBannerShownEvent = {
      event: 'navigation-app-install-banner-shown',
      nonInteractive: true,
    };

    if (Rover.context.appInstallBannerUpdates) {
      appInstallBannerShownEvent.treatment = 'variant';
      Rover.context.iOSReviewCount = '76.8k+ Reviews';
      Rover.context.androidReviewCount = '4,300+ Reviews';
    } else {
      appInstallBannerShownEvent.treatment = 'control';
      Rover.context.iOSReviewCount = '2,140+ Reviews';
      Rover.context.androidReviewCount = '2,300+ Reviews';
    }

    dataLayer.push({ ...appInstallBannerShownEvent });

    const routeURL = getRouteURL();

    $('body').addClass('has-banner');
    $('.js-app-banner').removeClass('hidden');
    $('.js-app-install-link').attr('href', routeURL);
    $('.js-close-app-banner').on('click', this.closeBanner);
    if (isAndroid()) {
      $('.js-review-count').text(Rover.context.androidReviewCount);
    } else {
      $('.js-review-count').text(Rover.context.iOSReviewCount);
    }
  }
}



// WEBPACK FOOTER //
// ./js/AppInstallBanner.js